// flash of unstyled content

$(window).on('load', () => {
  // ロード時に一瞬スタイルが適用されない問題を防ぐ
  $('.no-fuoc').removeClass('no-fuoc')

  // Materil UIのtextareaの高さが0で初期表示されてしまうので調整
  $('textarea.MuiInput-inputMultiline').each((i, el) => {
    const rows = el.getAttribute('rows') ?? 1
    el.style.height = `${19 * rows}px`
    if (el.disabled) {
      el.style.overflow = null
      el.style.overflowX = 'hidden'
      el.style.overflowY = 'scroll'
    }
  })
})
